import React from 'react';
import { motion } from 'framer-motion';
import { X, CheckCircle } from 'lucide-react';
export function BlindajeTotal() {
  const comparisons = [{
    situation: 'Paciente con dolor de rodilla que viene de cadera',
    without: 'Tratás la rodilla y el problema vuelve',
    with: 'Protocolo de cadera integrado. Listo.'
  }, {
    situation: 'Inestabilidad de tobillo que compromete la rodilla',
    without: 'Improvisás la evaluación',
    with: 'Fichas de tobillo y propiocepción. Ya están.'
  }, {
    situation: 'Alta clínica y el paciente recae a los 3 meses',
    without: 'No tenés protocolo de mantenimiento',
    with: 'Sistema de prevención de recaída incluido'
  }, {
    situation: 'Paciente deportivo con lesión en cadena',
    without: 'Protocolo parcial, resultados parciales',
    with: 'Visión completa cadera-rodilla-tobillo'
  }];
  const includes = ['Protocolo completo de cadera (coxartrosis, bursitis, tendinopatías)', 'Sistema de tobillo (esguinces, inestabilidad crónica, retorno deportivo)', 'Integración cadena cinética completa', 'Fichas de prevención de recaída', 'Protocolo de mantenimiento post-alta'];
  return <section className="w-full bg-[#0a1410] py-8 md:py-16" data-id="element-14">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-16">
          {/* Header */}
          <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-6 md:mb-12" data-id="element-17">
            🦵 ¿QUÉ AGREGA EL MÉTODO BLINDAJE TOTAL?
          </h2>

          {/* Comparison Table */}
          <div className="mb-6 md:mb-12 overflow-x-auto" data-id="element-18">
            <div className="bg-[#0f1f17] border border-amber-900/30 rounded-lg overflow-hidden min-w-[600px]" data-id="element-19">
              {/* Header Row */}
              <div className="grid grid-cols-3 gap-4 p-4 bg-[#0a1410] border-b border-amber-900/30" data-id="element-20">
                <div className="font-bold text-white" data-id="element-21">Situación clínica</div>
                <div className="font-bold text-red-500" data-id="element-22">❌ Sin el Manual</div>
                <div className="font-bold text-amber-500" data-id="element-23">✅ Con el Manual</div>
              </div>

              {/* Data Rows */}
              {comparisons.map((row, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1,
              duration: 0.4
            }} className="grid grid-cols-3 gap-4 p-4 border-b border-amber-900/20 last:border-b-0" data-id="element-24">
                  <div className="text-gray-300 text-sm" data-id="element-25">{row.situation}</div>
                  <div className="text-gray-400 text-sm" data-id="element-26">{row.without}</div>
                  <div className="text-amber-400 text-sm font-semibold" data-id="element-27">
                    {row.with}
                  </div>
                </motion.div>)}
            </div>
          </div>

          {/* Includes */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-[#0f1f17] border border-amber-900/30 rounded-lg p-6 md:p-8" data-id="element-28">
            <h3 className="text-xl md:text-2xl font-bold text-white mb-4 md:mb-6 text-center" data-id="element-29">
              ✅ EL MANUAL MAESTRO INCLUYE:
            </h3>
            <div className="space-y-3 md:space-y-4" data-id="element-30">
              {includes.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-31">
                  <CheckCircle className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" data-id="element-32" />
                  <p className="text-gray-300" data-id="element-33">{item}</p>
                </div>)}
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}